import { render, staticRenderFns } from "./Listitem.vue?vue&type=template&id=af34d0ca&scoped=true&"
import script from "./Listitem.vue?vue&type=script&lang=ts&"
export * from "./Listitem.vue?vue&type=script&lang=ts&"
import style0 from "./Listitem.vue?vue&type=style&index=0&id=af34d0ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af34d0ca",
  null
  
)

export default component.exports